import { render, staticRenderFns } from "./PreliminaryReportHCP.vue?vue&type=template&id=718e4da2&"
import script from "./PreliminaryReportHCP.vue?vue&type=script&lang=ts&"
export * from "./PreliminaryReportHCP.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports